<template>
    <div v-loading="pageLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top">
            <el-card header="基本信息">
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="title" label="活动名称:">
                            <el-input placeholder="请输入活动名称" v-model="formData.title" size="medium"
                                maxlength="40"></el-input>
                            <small>该名称显示在活动列表页、详情页</small>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="articleTitle" label="分享名称:">
                            <el-input placeholder="请输入分享名称" v-model="formData.articleTitle" size="medium"
                                maxlength="100"></el-input>
                            <small>该名称显示在分享出去的信息流中以及WAP站、小程序的活动列表页、详情页</small>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="showRank" label="是否展示排行榜:">
                            <el-radio-group v-model="formData.showRank" size="medium">
                                <el-radio :label="0" border>否</el-radio>
                                <el-radio :label="1" border>是</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="jumpUrl" label="跳转:">
                            <el-input
                                :placeholder="formData.jumpType < 3 ? '请输入跳转目标ID' : formData.jumpType == 3 ? '请输入跳转链接' : ''"
                                v-model="formData.jumpUrl" size="medium" maxlength="200"
                                :disabled="formData.jumpType == 4 ? true : false">
                                <el-select v-model="formData.jumpType" slot="prepend"
                                    @change="() => { formData.jumpType == 4 ? formData.jumpUrl = '' : '' }">
                                    <el-option :value="1" label="演出"></el-option>
                                    <el-option :value="2" label="周边"></el-option>
                                    <el-option :value="3" label="外部网页"></el-option>
                                    <el-option :value="4" label="不跳转"></el-option>
                                </el-select>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>
            <el-card header="活动时间" class="MT20">
                <el-form-item prop="onTime" style="margin-bottom: 0;">
                    <span slot="label">设置展示时间: <small>不在时间段内时，乐迷端不展示活动入口</small></span>
                </el-form-item>
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="onTime" label="">
                            <el-date-picker v-model="formData.onTime" type="datetime" placeholder="请选择活动展示开始时间"
                                value-format="yyyy-MM-dd HH:mm:ss" size="medium">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="offTime" label="">
                            <el-date-picker v-model="formData.offTime" type="datetime" placeholder="请选择活动展示结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss" size="medium">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item prop="startTime" style="margin-bottom: 0;">
                    <span slot="label">设置有效时间: <small>不在时间段内时，用户无法参与活动</small></span>
                </el-form-item>
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="startTime" label="">
                            <el-date-picker v-model="formData.startTime" type="datetime" placeholder="请选择活动开始时间"
                                value-format="yyyy-MM-dd HH:mm:ss" size="medium">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="endTime" label="">
                            <el-date-picker v-model="formData.endTime" type="datetime" placeholder="请选择活动结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss" size="medium">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>
            <el-card header="图片&音乐" class="MT20">
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="listImg" label="活动列表图:">
                            <img-upload :url.sync="listImg" :urlFull.sync="formData.listImg">
                                <el-link slot="size" type="primary"
                                    href="https://wap.showstart.com/pages/helpCenter/help/help?terminal=2&menuId=28"
                                    target="_blank">查看尺寸规范</el-link>
                            </img-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="poster" label="活动详情图:">
                            <img-upload :url.sync="poster" :urlFull.sync="formData.poster">
                                <el-link slot="size" type="primary"
                                    href="https://wap.showstart.com/pages/helpCenter/help/help?terminal=2&menuId=28"
                                    target="_blank">查看尺寸规范</el-link>
                            </img-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="40">
                    <el-col :xs="24" :xl="16">
                        <el-form-item prop="images" label="活动套图:">
                            <el-upload action="" list-type="picture-card" accept="image/png,image/jpeg"
                                :http-request="uploadImage" multiple :on-remove="imageRemove"
                                :before-upload="beforeImageUpload" :file-list="imageList">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :xl="16">
                        <el-form-item prop="musicUri" label="背景音乐:">
                            <el-row :gutter="40" type="flex" :key="formData.musicUri">
                                <el-col :span="6">
                                    <el-upload action :http-request="uploadMusic" ref="uploadMp3" accept="audio/mpeg,audio/wav"
                                        :show-file-list="false" :disabled="uploadMP3Loading">
                                        <el-button type="primary" icon="el-icon-upload" size="medium"
                                            :loading="uploadMP3Loading">上传MP3或WAV</el-button>
                                    </el-upload>
                                </el-col>
                                <el-col :span="6">
                                    <el-button v-if="formData.musicUri" size="medium" type="text" icon="el-icon-video-play" @click="$player.play({playUrl:formData.musicUri})">试听</el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>

            <el-card header="门槛设置（活动玩法）" class="MT20">
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="pv" label="PV要求达到:">
                            <el-input-number style="width:100%" v-model="formData.pv" :precision="0"
                                controls-position="right" :min="1" :max="99999999" size="medium"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="uv" label="UV要求达到:">
                            <el-input-number style="width:100%" v-model="formData.uv" :precision="0"
                                controls-position="right" :min="1" :max="99999999" size="medium"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="40">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="registerNum" label="注册数要求达到:">
                            <el-input-number style="width:100%" v-model="formData.registerNum" :precision="0"
                                controls-position="right" :min="1" :max="99999999" size="medium"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="orderNum" label="订单要求达到:">
                            <el-input-number style="width:100%" v-model="formData.orderNum" :precision="0"
                                controls-position="right" :min="1" :max="99999999" size="medium"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>

            <el-card header="微博话术&关联演出" class="MT20">
                <el-row :gutter="40">
                    <el-col :xs="24" :xl="16">
                        <el-form-item prop="blogShareTalk" label="微博话术:">
                            <el-input type="textarea" placeholder="请输入微博自定义话术"
                                v-model="formData.blogShareTalk"></el-input>
                            <small>
                                默认话术格式：
                                <span class="color-danger">我在秀动发现【文章标题】很有趣，快来看看吧</span>
                                <span class="color-blue">@秀动ShowStart【文章链接】</span>
                            </small>
                            <el-alert title="请注意" type="warning" :closable="false" show-icon>
                                1、如果不填写话术，则系统自动使用默认话术<br />2、填写了自定义话术后，只会替换分享话术中红色的文案部分，蓝色的文案无法更改
                            </el-alert>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :xl="16">
                        <el-form-item prop="activityIdList" label="关联演出:">
                            <el-input v-model="activityParams.activityId" class="input-with-select"
                                :placeholder="activityParams.type == 1 ? '请输入演出ID' : '请输入巡演ID'" size="medium">
                                <el-select v-model="activityParams.type" slot="prepend" placeholder="请选择">
                                    <el-option label="演出ID" :value="1"></el-option>
                                    <el-option label="巡演ID" :value="2"></el-option>
                                </el-select>
                                <el-button slot="append" icon="el-icon-circle-plus" @click="searchEvent">添加</el-button>
                            </el-input>
                            <small class="from-tip"><span class="el-icon-warning"></span> 通过ID查询并绑定相关演出</small>
                            <el-table v-if="activities && activities.length > 0" :data="activities" border
                                style="width: 100%" size="small">
                                <el-table-column prop="id" label="演出ID"></el-table-column>
                                <el-table-column prop="name" label="演出名称"></el-table-column>
                                <el-table-column fixed="right" label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" icon="el-icon-delete"
                                            @click="delActivity(scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>

            <el-card header="其他信息" class="MT20">
                <el-row :gutter="40">
                    <el-col :xs="24" :xl="16">
                        <el-form-item prop="rule" label="活动规则描述:">
                            <tinymce v-model="formData.rule" :toolbar="toolbar" :menubar="false" v-if="reFresh">
                            </tinymce>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :xl="16">
                        <el-form-item prop="detail" label="活动详情:">
                            <tinymce v-model="formData.detail" :toolbar="toolbar" :menubar="false" v-if="reFresh">
                            </tinymce>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>

            <!-- <el-row :gutter="40">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="autoSendReward" label="发奖模式:">
                        <el-radio-group v-model="formData.autoSendReward" size="medium">
                            <el-radio :label="0">人工发奖</el-radio>
                            <el-radio :label="1">自动发奖</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <manual-award v-if="formData.autoSendReward == 1" :form-data.sync="formData"></manual-award>
                </el-col>
            </el-row> -->

            <el-form-item class="MT20">
                <el-button @click="goBack">返回取消</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading">确认提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Tinymce from '@/components/Tinymce';
import ImgUpload from '@/components/ImageUpload';
import { uploadImg, uploadAudio } from '@/assets/js/commonApi';
// import ManualAward from './components/manualAward';
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components: {
        Tinymce,
        ImgUpload,
        // ManualAward
    },
    data() {
        return {
            formData: {
                title: "",
                articleTitle: "",
                showRank: 0,
                autoSendReward: 0,
                manualAward: 0,
                onTime: '',
                startTime: '',
                endTime: '',
                offTime: '',
                listImg: '',
                poster: '',
                jumpType: 1,
                jumpUrl: '',
                method: 1,
                pv: undefined,
                uv: undefined,
                registerNum: undefined,
                orderNum: undefined,
                blogShareTalk: '',
                rule: '',
                detail: '',
                couponId: '',
                couponNum: '',
                goodsSkuId: '',
                goodsNum: '',
                openDeliveryAddress: 0,
                awardPlace: '活动现场',
                images: [],
                musicUri: ""
            },
            rules: {
                title: [{ required: true, message: "请输入活动名称" }],
                articleTitle: [{ required: true, message: "请输入分享名称" }],
                onTime: [{ required: true, message: "请选择活动展示开始时间" }],
                startTime: [{ required: true, message: "请选择活动开始时间" }],
                endTime: [{ required: true, message: "请选择活动结束时间" }],
                offTime: [{ required: true, message: "请选择活动展示结束时间" }],
                listImg: [{ required: true, message: "请上传活动列表图" }],
                poster: [{ required: true, message: "请上传活动详情图" }],
                rule: [{ required: true, message: "请输入活动规则" }],
                detail: [{ required: true, message: "请输入活动详情" }]
            },
            btnLoading: false,
            pageLoading: false,
            redirect: this.$route.query.redirect || "/promotion/shareActivity/list",
            reFresh: false,
            v: this.$route.query.v || '',
            toolbar: ['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media | preview fullscreen'],
            listImg: '',
            poster: '',
            activityParams: {
                activityId: '',
                type: 1
            },
            activities: [],
            imageList: [],
            uploadMP3Loading: false
        };
    },
    created() {
        this.imageList = [];
        if (this.id) {
            this.getData();
        } else {
            this.reFresh = true;
        }
    },
    methods: {

        // 获取详情
        getData() {
            this.pageLoading = true;
            this.$request({
                url: "/share/activity/detail",
                method: "POST",
                params: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    this.formData = {
                        ...result,
                        pv: result.pv != 0 ? result.pv : undefined,
                        uv: result.uv != 0 ? result.uv : undefined,
                        registerNum: result.registerNum != 0 ? result.registerNum : undefined,
                        orderNum: result.orderNum != 0 ? result.orderNum : undefined,
                        images: result?.images?.split(',') || []
                    }
                    this.activities = result.activities ? result.activities : []
                    this.listImg = result.listImg;
                    this.poster = result.poster;

                    const _imageList = result?.images ? result.images.split(',') : []
                    this.imageList = _imageList.length > 0 ? _imageList.map(v => { return { url: v } }) : []

                    this.reFresh = true;
                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            }).finally(() => {
                this.pageLoading = false;
            });
        },
        //搜索演出事件
        searchEvent() {

            if (this.activityParams.activityId !== "") {
                this.dataLoading = true;
                this.$request({
                    url: "/shop_good/activity",
                    params: this.activityParams,
                    method: "post",
                })
                    .then((res) => {
                        const { state, result, msg } = res.data;
                        if (state == 1 && result && result.length > 0) {
                            this.dataLoading = false
                            result.map(item => {
                                const _obj = this.activities.find(v => v.id == item.id && v.name == item.name);
                                if (!_obj) {
                                    this.activities.push(item);
                                }
                            })
                        } else {
                            this.$message.error(msg || '没有找到相关演出');
                            this.dataLoading = false
                        }
                    })
            }
        },
        //删除演出
        delActivity(v) {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.activities = this.activities.filter(item => item !== v);
            }).catch(() => { })
        },
        //表单提交
        onSubmit() {
            var _activityIds = []
            if (this.activities && this.activities.length > 0) {
                this.activities.map(item => {
                    _activityIds.push(item.id)
                })
            }
            //console.log(_activityIds)

            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    const _onTime = new Date(this.formData.onTime).getTime(),
                        _startTime = new Date(this.formData.startTime).getTime(),
                        _endTime = new Date(this.formData.endTime).getTime(),
                        _offTime = new Date(this.formData.offTime).getTime();
                    if (_onTime > _startTime) {
                        return this.$message.error('展示开始时间不能晚于活动开始时间');
                    }
                    if (_startTime > _endTime) {
                        return this.$message.error('活动开始时间不能晚于活动结束时间');
                    }
                    // if (_endTime > _offTime) {
                    //     return this.$message.error('活动展示结束时间不能早于活动结束时间');
                    // }
                    if (!this.formData.pv && !this.formData.uv && !this.formData.registerNum && !this.formData.orderNum) {
                        return this.$message.error('请填写活动玩法');
                    }
                    if (this.formData.couponId && !this.formData.couponNum) {
                        return this.$message.error('请输入优惠券发奖数量');
                    }
                    if (this.formData.goodsSkuId && !this.formData.goodsNum) {
                        return this.$message.error('请输入周边实物发奖数量');
                    }
                    this.btnLoading = true;
                    
                    this.$request({
                        url: !this.id ? "/share/activity/create" : "/share/activity/update",
                        method: "POST",
                        data: {
                            ...this.formData,
                            listImg: this.listImg,
                            poster: this.poster,
                            couponNum: !this.formData.couponId ? '' : this.formData.couponNum,
                            goodsNum: !this.formData.goodsSkuId ? '' : this.formData.goodsNum,
                            pv: this.formData.pv || 0,
                            uv: this.formData.uv || 0,
                            registerNum: this.formData.registerNum || 0,
                            orderNum: this.formData.orderNum || 0,
                            activityIds: _activityIds.toString(),
                            images: this.formData.images.toString()
                        },
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        },

        async uploadImage(req) {
            const {
                file,
                file: { type, size },
            } = req;

            //格式检查
            const formatVerified =
                type === "image/jpeg" || file.type === "image/png";
            if (!formatVerified) {
                this.$message.error("文件格式存在错误，请重新上传");
                return;
            }
            //大小检查
            const bytesVerified = size / 1024 / 1024 < 10;
            if (!bytesVerified) {
                this.$message.error("图片尺寸错误,请重新上传");
                return;
            }

            // 上传图片
            const formData = new FormData();
            formData.append("file", file);

            // this.uploadLoading = true;
            const res = await uploadImg(formData, () => {
                // this.progress = Math.floor((ev.loaded / ev.total) * 100);
            }).finally(() => {
                // this.uploadLoading = false;
            });

            const { state, result, msg } = res.data;
            if (state == 1) {
                this.imageList.push({
                    url: result.urlFull
                });
                this.formData.images.push(result.urlFull);
            } else {
                this.$message.error(msg || '上传失败');
            }
        },
        imageRemove(file, fileList) {
            const _index = this.imageList.findIndex(v => v === file);

            this.formData.images = this.formData.images.filter((v, i) => i !== _index);

            this.imageList = fileList;
        },
        beforeImageUpload(file) {
            this.imageList = this.imageList.filter(v => v !== file)
        },
        async uploadMusic(req){
            const {file} = req;
            
            const isType = file.type === 'audio/mpeg' || file.type === 'audio/wav';
            if (!isType) {
                return this.$message.error('只能上传MP3或WAV格式的音频!');
            }

            this.uploadMP3Loading = true;
            const formData = new FormData();
            formData.append('file', file);

            // let filePath;
            const res = await uploadAudio(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
                this.formData.musicUri = '';
            }).finally(() => {
                this.uploadMP3Loading = false;
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                this.$nextTick(() => {
                    this.formData.musicUri = result.urlFull;
                })
            }else{
                this.$message.error(msg || '上传失败');
                this.formData.musicUri = '';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.el-date-editor.el-input {
    width: 100%;
}

.el-alert {
    line-height: normal;
}
</style>